import React, { useState } from "react";
import { motion } from "framer-motion";
import "./BookSection.css";

const BookDemoSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    role: "",
    message: ""
  });
  const [status, setStatus] = useState("idle"); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const response = await fetch("/api/book-demo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", company: "", role: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <motion.section
      className="book-demo-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}
      id="book-demo"
    >
      <div className="book-demo-container">
        
        <motion.div 
          className="book-demo-content"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2>Ready to Transform Your Workflow?</h2>
          <p>
            See how our platform helps industry leaders achieve 3x efficiency. 
            Schedule a personalized demo with our expert team today.
          </p>
          
          <ul className="feature-list">
            <li>Personalized walkthrough of key features</li>
            <li>Q&A session with product experts</li>
            <li>Custom pricing tailored to your needs</li>
            <li>No commitment required</li>
          </ul>
        </motion.div>

        <motion.div 
          className="book-demo-form-wrapper"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <h3>Book Your Demo</h3>
          <p className="subtitle">Fill out the form and we'll be in touch within 24 hours.</p>

          {status === "success" ? (
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              style={{ textAlign: 'center', padding: '40px 20px' }}
            >
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
              <h4 style={{ color: '#459BA7', marginBottom: '8px' }}>Request Received!</h4>
              <p style={{ color: '#6b7280' }}>Thanks {formData.name || 'there'}, check your inbox for confirmation.</p>
              <button 
                onClick={() => setStatus("idle")} 
                className="secondary-btn" 
                style={{ marginTop: '20px', background: 'transparent', border: '1px solid #459BA7', color: '#459BA7', padding: '8px 20px', borderRadius: '8px', cursor: 'pointer' }}
              >
                Submit Another
              </button>
            </motion.div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John Doe"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Work Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@company.com"
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Acme Inc."
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="role">Job Title</label>
                  <input
                    type="text"
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    placeholder="Product Manager"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">What would you like to discuss?</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your specific needs..."
                  rows={3}
                />
              </div>

              <button 
                type="submit" 
                className="submit-btn"
                disabled={status === "loading"}
              >
                {status === "loading" ? "Sending..." : "Schedule Demo"}
              </button>
              
              {status === "error" && (
                <p style={{ color: '#ef4444', fontSize: '0.9rem', marginTop: '10px', textAlign: 'center' }}>
                  Something went wrong. Please try again or contact us directly.
                </p>
              )}
            </form>
          )}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default BookDemoSection;